import React from 'react';
import PropTypes from 'prop-types';

import { FlexColumn } from 'ui-components/components/flex';
import { Text, TextType } from 'ui-components/components/text';

import { emptyArray } from 'ui-components/default-props/empty';
import { MessageDescriptorPropType } from '../../../../../prop-types/intl';
import { SubscriptionCardSectionLineItem } from './section-line-item';

export const SubscriptionCardSection = ({ title, lineItems = emptyArray }) => {
  return (
    <FlexColumn>
      <Text textType={TextType.H4} value={title} />
      {lineItems.map((lineItem) => (
        <SubscriptionCardSectionLineItem key={lineItem.lineItemCode} lineItem={lineItem} />
      ))}
    </FlexColumn>
  );
};

SubscriptionCardSection.propTypes = {
  title: PropTypes.oneOfType([PropTypes.node, MessageDescriptorPropType]).isRequired,
  lineItems: PropTypes.array,
};
